import { forwardRef, type CSSProperties } from 'react';
import { safeDisplayUrl } from '../safeDisplayUrl';
import { cn } from '../base/utils';

export interface WebPreviewFrameProps {
  src: string;
  title: string;
  className?: string;
  style?: CSSProperties;
}

export const WebPreviewFrame = forwardRef<HTMLIFrameElement, WebPreviewFrameProps>(function WebPreviewFrame({ src, title, className, style, ...attributes }, ref) {
  const safe = safeDisplayUrl(src, 'media');
  const source = safe && !safe.startsWith('blob:') ? safe : undefined;
  return <iframe {...attributes} ref={ref} src={source} title={title} data-monkeys-component="web-preview-frame" data-invalid-source={!source || undefined}
    sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation" referrerPolicy="no-referrer"
    className={cn('h-full min-h-80 w-full border-0 bg-background', className)} style={style} />;
});
